import { ReactElement } from 'react';
import { MakeHeadingSt, MakeIconSt, MakeTitleWrapperSt } from './MakeTitle.css';

export interface IMakeTitleProps {
  heading: string;
  make: string;
}

const MakeTitle = ({ heading, make }: IMakeTitleProps): ReactElement => {
  return (
    <MakeTitleWrapperSt>
      <MakeIconSt
        src={`/assets/makes/lp/${make?.toLowerCase()}.png`}
        alt={`Icon for ${make} make`}
      />
      <MakeHeadingSt>{heading}</MakeHeadingSt>
    </MakeTitleWrapperSt>
  );
};

export default MakeTitle;
